import { setTokens } from "../../setup/api";

const saveAuthTokens = response => {
  const { token, refresh } = response.data;
  setTokens(token, refresh);
};

export default {
  login(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/accounts/signin", data)
        .then(function(response) {
          saveAuthTokens(response);
          context.commit("setLogged", true);
          resolve();
        })
        .catch(reject);
    });
  },

  register(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/users/add", data)
        .then(function(response) {
          saveAuthTokens(response);
          context.commit("setLogged", true);
          resolve();
        })
        .catch(reject);
    });
  },

  forgot(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/accounts/forgot", data)
        .then(resolve)
        .catch(reject);
    });
  },

  resetPassword(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/accounts/reset-password", data)
        .then(resolve)
        .catch(reject);
    });
  },

  get(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/accounts/")
        .then(function(response) {
          context.commit("setUser", response.data);
          // context.dispatch("getUserProgress"); // no backend yet
          resolve();
        })
        .catch(reject);
    });
  },

  getCertificateStatus(context) {
    return new Promise((resolve, reject) => {
      const productId = context.rootGetters.activeProductId;
      window.axios
        .get(`/accounts/students/product/${productId}/certificate/status`)
        .then(function(response) {
          context.commit("setCertificateStatus", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  generateCertificate(context) {
    return new Promise((resolve, reject) => {
      const productId = context.rootGetters.activeProductId;
      window.axios
        .get(`accounts/students/product/${productId}/generate/certificate`)
        .then(function(response) {
          // context.commit("setCertificateStatus", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  update(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .put("/accounts/", data)
        .then(function() {
          context.commit("updateUser", data);
          resolve();
        })
        .catch(reject);
    });
  },

  updatePassword(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .put("/accounts/change-password", data)
        .then(resolve)
        .catch(reject);
    });
  },
  getNotifications(context) {
    return new Promise((resolve, reject) => {
      const productId = context.rootGetters.activeProductId;
      window.axios
        .get(`/notifications/product/${productId}/list`)
        .then(({ data }) => {
          context.commit("setNotifications", data.results);
          resolve({ ...data });
        })
        .catch(reject);
    });
  },
  // getNotification(context, id) {
  //   return new Promise((resolve, reject) => {
  //     window.axios
  //       .get("/notifications/" + id)
  //       .then(resolve)
  //       .catch(reject);
  //   });
  // },
  // getProductNotifications(context) {
  //   return new Promise((resolve, reject) => {
  //     const productId = context.rootState.setup.product_id;
  //     window.axios
  //       .get("/notifications/product/" + productId)
  //       .then(({ data }) => {
  //         context.commit("setNotifications", data.results);
  //         resolve({ ...data });
  //       })
  //       .catch(reject);
  //   });
  // },
  readNotification(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .put(`/notifications/${data.id}/read`, { is_read: true })
        .then(resolve)
        .catch(reject);
    });
  },
  // readAllNotifications(context, data) {
  //   return new Promise((resolve, reject) => {
  //     const productId = context.rootState.setup.product_id;
  //     window.axios
  //       .put(`/notifications/${data.product_id || productId}/read/all`, data)
  //       .then(resolve)
  //       .catch(reject);
  //   });
  // },
  getUserProgress(context) {
    return new Promise((resolve, reject) => {
      const name = context.rootState.setup.name;
      window.axios
        .get(`/courses/acquired?name_course=${name}`)
        .then(response => {
          context.commit("setCourseInfo", response.data.results[0]);
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  getIntegratUrl(context) {
    return new Promise((resolve, reject) => {
      const productId = context.rootGetters.activeProductId;
      window.axios
        .get(`/integrations/integrat/students/login/product/${productId}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(reject);
    });
  }
};
